import { render } from "./ModuleTypeIcon.vue?vue&type=template&id=3ca859d8"
import script from "./ModuleTypeIcon.vue?vue&type=script&lang=js"
export * from "./ModuleTypeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__